import React from "react";

export type User = {
  authenticated: boolean;
  username: string;
  id: number | null;
};

export const Context = React.createContext<Partial<User>>({});
